import React, { useMemo } from "react";
import Help from "../help/Help";
import { useLocation } from "react-router-dom";
import BalanceSheetHelp from "../help/BalanceSheet/BalanceSheetHelp";
import VoucherHelp from "../help/Voucher/VoucherHelp";
import LedgerVoucherHelp from "../help/Voucher/LedgerVoucherHelp";

// Constants for pathnames to avoid magic strings
const PATHS = {
  HOME: "/",
  BALANCE_SHEET: "/balancesheetreports",
  VOUCHER_TRANSACTION: "/voucherstransaction",
  LEDGER_VOUCHER: "/ledgervoucher"
};

// Version component extracted for reusability
const VersionDisplay = () => (
  <div style={{ position: "absolute", bottom: 5, width: "100%" }}>
    <div className="help_button_card ms-1">
      <button
        className="button_padding"
        style={{
          background: "white",
          paddingTop: 3,
          paddingBottom: 3,
          marginBottom: 2,
        }}
      >
        Version: 1.0.0
      </button>
    </div>
  </div>
);

const HomeLayout = ({ children, data, setData, displayNameOfVoucherType }) => {
  const location = useLocation();

  // Memoized help content to prevent unnecessary re-renders
  const helpContent = useMemo(() => {
    const { pathname } = location;
    
    switch (true) {
      case pathname === PATHS.HOME:
        return <VersionDisplay />;
      case pathname === PATHS.BALANCE_SHEET:
        return <BalanceSheetHelp />;
      case pathname === PATHS.VOUCHER_TRANSACTION:
        return (
          <VoucherHelp
            data={data}
            setData={setData}
            displayNameOfVoucherType={displayNameOfVoucherType}
          />
        );
      case pathname.includes(PATHS.LEDGER_VOUCHER):
        return <LedgerVoucherHelp />;
      default:
        return null;
    }
  }, [location.pathname, data, setData, displayNameOfVoucherType]);

  return (
    <div className="section">
      <div className="detail">
        {children}
      </div>
      <Help>
        {helpContent}
      </Help>
    </div>
  );
};

export default React.memo(HomeLayout);
